import { Link } from 'react-router-dom';
import '../App.css';

export default function Home() {
    return (
        <div className="flex flex-col w-full h-full flex-1">
            <div className="flex justify-left gap-7">
                <img className="profile-image" alt="Profile" src={require('../assets/profile.jpg')}></img>
                <div className="flex flex-col items-start">
                    <header className="site-heading text-4xl">Jenna Permut</header>
                    <div className="hero-role text-left text-xl">Digital Storyteller ( Developer / Storyteller )</div>
                </div>
            </div>

            <div className="intro-editorial text-left mt-10">
                Hello! My name is Jenna, and I’m an engineer with 4+ years of experience developing and maintaining consumer-facing products for the themed entertainment industry.
                <p className="mt-3 text-primary font-medium">I blend engineering and storytelling to create digital experiences that feel clear, playful, and human.</p>
            </div>

            <div className="editorial-divider"></div>

            <div className="text-left mb-4">
                <div className="section-title text-xl text-left mb-3">I'm interested in: </div>
                <ul className="list-disc list-inside w-full">
                    <li>Building intuitive, engaging products that make complex information easy to understand</li>
                    <li>Leveraging AI workflows to prototype quickly, validate ideas, and turn ambiguous product concepts into polished features</li>
                    <li>Creating developer tools and systems that help teams move faster</li>
                </ul>
            </div>

            <div className="editorial-divider"></div>

            <div className="section-title text-xl text-left my-5">TL;DR</div>
            <div className="flex flex-col items-start mb-10 text-primary">
                <AppLink>
                    <Link to="/resume" className="flex gap-2 items-baseline font-medium ">
                        <i className="fa-solid fa-briefcase"></i>
                        <span>Résumé</span>
                    </Link>
                </AppLink>
            </div>

            <div className="editorial-divider"></div>

            <div className="section-title text-xl text-left my-5">Connect with me!</div>
            <div className="flex flex-col items-start center-primary">
                <AppLink>
                    <a
                        className="flex gap-2 items-baseline font-medium "
                        href="https://github.com/jennapermut"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <i className="fa-brands fa-github fa-fw"></i>
                        <div>@jennapermut</div>
                    </a>
                </AppLink>
                <AppLink>
                    <a
                        className="flex gap-2 items-baseline font-medium "
                        href="https://www.linkedin.com/in/jennapermut"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <i className="fa-brands fa-linkedin fa-fw"></i>
                        <div>@jennapermut</div>
                    </a>
                </AppLink>
            </div>
        </div>
    );
}

function AppLink({ children }) {
    return (
        <div className="flex gap-2 px-2 py-2 text-primary cursor-pointer rounded items-baseline hover:bg-secondary duration-75">
            {children}
        </div>
    );
}
